import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

interface UserSignInProps {
  sourceUserId: string
  code: string
}

export const userSignIn = async (data: UserSignInProps) => {
  return await useAxios.post(
    `${DND_SERVICE}/v1/authentication/authenticate`,
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

export const validateCookie = async () => {
  try {
    const response = await useAxios.get(`${DND_SERVICE}/v1/authentication/validate-cookie`, )
    return response.data
  } catch (error) {
    console.error('Cookie validation failed:', error)
    return null
  }
}